import { applyMiddleware, createStore } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';
import logger from 'redux-logger';

import { reducers as rootReducer } from './redux';

function ConfigureStore() {
  /**
   * Persist reducer
   */
  const persistedReducer = persistReducer({
    key: 'rcaw',
    storage,
    blacklist: ['secured', 'campaign']
  }, rootReducer);


  /**
   * Apply middlewares
   */
  const middlewares = [
    thunk
  ];

  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(logger);
  }


  /**
   * Create store
   */
  const store = createStore(
    persistedReducer,
    applyMiddleware(
      ...middlewares
    )
  );


  /**
   * Persistor to give it to PersistGate
   */
  const persistor = persistStore(store);

  return { store, persistor };
}

export default ConfigureStore();
